module.exports = __webpack_public_path__ + "static/media/Settings.14ec4ca4.png";